// frontend/src/pages/RequestPasswordResetPage.js
import React, { useState } from 'react';
import  api  from '../services/api';
import { Link } from 'react-router-dom';

function RequestPasswordResetPage() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');

        try {
            const response = await api.post('/auth/request-password-reset', { email });
            setMessage(response.data.message);
        } catch (err) {
            setError('Ocurrió un error. Por favor, inténtalo de nuevo.');
            console.error(err);
        }
    };

    return (
        <div className="container mt-5" style={{ maxWidth: '500px' }}>
            <div className="card shadow-sm">
                <div className="card-body p-4">
                    <h2 className="card-title text-center mb-4">Restablecer Contraseña</h2>
                    <p className="text-muted text-center mb-3">
                        Ingresa tu email y te enviaremos un enlace para restablecer tu contraseña.
                    </p>

                    {message && <div className="alert alert-success">{message}</div>}
                    {error && <div className="alert alert-danger">{error}</div>}

                    {!message && (
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <button type="submit" className="btn btn-primary w-100">Enviar Enlace</button>
                        </form>
                    )}

                    <div className="text-center mt-3">
                        <Link to="/login">Volver a Iniciar Sesión</Link>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RequestPasswordResetPage;